export default __webpack_public_path__ + "static/media/Xiaomi Redmi Note 9 Pro.ff71d4da.png";